import { render, staticRenderFns } from "./AddFriend.vue?vue&type=template&id=d7163dee&scoped=true"
import script from "./AddFriend.vue?vue&type=script&lang=js"
export * from "./AddFriend.vue?vue&type=script&lang=js"
import style0 from "./AddFriend.vue?vue&type=style&index=0&id=d7163dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../T88/build-source/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7163dee",
  null
  
)

export default component.exports